const FALLBACK = "Алдаа гарлаа дахин оролдож үзнэ үү";

// Rest API маань алдааг { success: false, error: "мессеж" } хэлбэрээр буцаадаг,
// өөрөөр хэлбэл error нь ЮМС биш ТЕКСТ. Өмнө нь энд error.message гэж уншиж
// байсан тул үргэлж undefined гарч, toast огт харагдахгүй байсан.
// Энд бүх боломжит хэлбэрийг зөв уншина.
export const errorMessage = (error) => {
  if (!error) return FALLBACK;

  // axios биш, зүгээр текст дамжуулсан бол
  if (typeof error === "string") return error.trim() || FALLBACK;

  const response = error.response;
  const data = response && response.data;

  if (data) {
    const apiError = data.error !== undefined ? data.error : data.message;

    if (typeof apiError === "string" && apiError.trim()) return apiError.trim();

    if (
      apiError &&
      typeof apiError.message === "string" &&
      apiError.message.trim()
    ) {
      return apiError.message.trim();
    }

    if (typeof data === "string" && data.trim()) return data.trim();
  }

  if (typeof error.message === "string" && error.message.trim()) {
    return error.message.trim();
  }

  if (response && response.status) {
    return `${FALLBACK} (${response.status})`;
  }

  return FALLBACK;
};

export default errorMessage;
